module.exports = __webpack_public_path__ + "img/ertiga-booster-greenForm.1c7c14d5.svg";